import { put, takeLatest } from "redux-saga/effects";
import http from "api";
import {
  UPDATE_FILTERS,
  REQUEST_SEARCH_RESULTS,
  RECEIVE_SEARCH_RESULTS,
  MOST_RECENT_CATALOG_URL,
  CHANGE_SEARCH_RESULT_PAGE
} from "./actions";
import * as FILTERS from "constants/filters";
import { createPublicUrlPath } from "./helpers";
import { history } from "store";
import LEGACY_FILTER_MAP from "data/legacy-filter-map";

/**
 * Build API query.
 *
 * Build GET request to private API.
 *
 * @param {string} doorType Door type.
 * @param {Object[]} filterOptions Filter options.
 * @param {number} page Page number.
 */
function buildApiQuery(doorType, filterOptions, page = 1) {
    let options = {};

    filterOptions = transposeLegacyFilters(filterOptions);

    filterOptions.forEach(function (option, index) {
        const taxonomyWithTermId = option.hash.replace(/^L/, '').toLowerCase();
        const taxonomy = taxonomyWithTermId.replace(/\d+$/, "");
        const termId = taxonomyWithTermId.replace(/^\D+/g, ''); // Replace all leading non-digits with nothing.
        options[taxonomy] = termId;
    });

    const params = new URLSearchParams(options);
    const filterParams = params.toString();

    let doorTypeIds;
    // if (doorType === 'exterior') {
    //     doorTypeIds = FILTERS.EXTERIOR_DOOR_TYPE_IDS;
    // } else if (doorType === 'interior') {
    //     doorTypeIds = FILTERS.INTERIOR_DOOR_TYPE_IDS;
    // }

    doorTypeIds = FILTERS.INTERIOR_DOOR_TYPE_IDS;

    const doorTypeArg = `door_type=${doorTypeIds}`;
    const pageArg = `page=${page}`;
    const perPageArg = 'per_page=30';

    return (
        "/doors?" +
        [pageArg, perPageArg, filterParams]
        .filter(v => v)
        .join("&")
    );
}

/**
 * Update search results.
 *
 * Sets a loading state, gets doors from API, update page, and corrects the
 * URL, if necessary.
 *
 * @param {Object} action Redux action.
 */
export function* updateSearchResultsAsync(action) {
  const { filterOptions, doorType, pathPrefix, page = 1 } = action.payload;
  const { location } = history;
  const query = buildApiQuery(doorType, filterOptions, page);

  yield put({ type: REQUEST_SEARCH_RESULTS });

  try {
    const response = yield http.get(query);
    const nextState = response.data;

    yield put({
      type: RECEIVE_SEARCH_RESULTS,
      payload: nextState
    });

    const currentUrl = `${location.pathname}${location.search}${location.hash}`;
    const shouldBeUrl = createPublicUrlPath(
      pathPrefix,
      nextState.filters,
      [],
      page,
      location.search
    );

    if (currentUrl !== shouldBeUrl) {
      history.replace(shouldBeUrl);
    }

    yield put({ type: MOST_RECENT_CATALOG_URL, payload: shouldBeUrl });
  } catch (error) {
    console.log("error", error);
  }
}

export default function* catalogRootSaga() {
  yield takeLatest(CHANGE_SEARCH_RESULT_PAGE, updateSearchResultsAsync);
  yield takeLatest(UPDATE_FILTERS, updateSearchResultsAsync);
}

/**
 * Transposes any possible legacy filters.
 * @param {*} filterOptions
 * @returns
 */
function transposeLegacyFilters(filterOptions) {
    const transposedFilterOptions = filterOptions.map(item => {
        let mappedItem = LEGACY_FILTER_MAP.find(filterMapItem => filterMapItem.legacy_option_id === item.hash);

        if (mappedItem) {
            const mappedItemObject = {
                hash: mappedItem.option_id,
                selected: true
            };

            return {
                ...item,
                ...mappedItemObject
            };
        } else {
            return item;
        }
    });

    return transposedFilterOptions;
}
